"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalTheme;
var _lodash = _interopRequireDefault(require("lodash.get"));
var _widgetSelectors = require("../store/widget/widgetSelectors");
var _themes = _interopRequireDefault(require("../components/vfuk/themes"));
var _useAppSelector = require("./useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useLocalTheme(path, defaultValue) {
  const config = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectConfig);
  const currentThemeName = (0, _lodash.default)(config, 'uiSettings.contextMap');
  const overwrittenTheme = currentThemeName && (0, _themes.default)(currentThemeName);
  if (!overwrittenTheme) return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
  return path ? (0, _lodash.default)(overwrittenTheme, path, defaultValue) : overwrittenTheme;
}